import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_UNIT_INCOME_RECORDS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_UNIT_INCOME_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_UNIT_INCOME_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_UNIT_INCOME_RECORD:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_UNIT_INCOME_RECORD:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
